import React from "react";
import { CheckCircle2Icon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerItems } from "../../data/landing";
export function Offer() {
  return <section id="offer" className="bg-navy px-4 py-16 text-white sm:py-20" data-id="element-172" data-mp="356vnkgxbnyxh">
      <div className="mx-auto max-w-2xl" data-id="element-173" data-mp="3a5gl28l6w4i8">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-174" data-mp="3a4dtrzjyg01s">
          Here's everything you'll <em className="italic text-sky" data-id="element-175" data-mp="3f2p8oop3x0qv">receive today</em>
        </h2>

        <img src={images.mockup} alt="Complete Liposuction Case Lab™ bundle" className="mx-auto mt-8 w-full" loading="lazy" data-id="element-176" data-mp="3jwbd5tl49ybl" />

        <div className="mt-6 rounded-3xl bg-white p-5 text-ink sm:p-8" data-id="element-177" data-mp="3nw25w2u7eoir">
          <ul className="divide-y divide-navy/10" data-id="element-178" data-mp="3sx9fm7fwpxs2">
            {offerItems.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3" data-id="element-179" data-mp="1qot910sre1d">
                <span className="flex items-start gap-2.5 text-[15px] font-semibold leading-snug text-navy" data-id="element-180" data-mp="1kmjbsqobkcz9">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-181" data-mp="1fllushf1pozc" />
                  {item.label}
                </span>
                <span className="shrink-0 text-sm font-semibold text-ink/50 line-through" data-id="element-182" data-mp="16lp3e819uc0l">{item.value ? `$${item.value}` : "Incl."}</span>
              </li>)}
          </ul>

          <div className="mt-4 rounded-2xl bg-cream p-4 text-center" data-id="element-183" data-mp="23dsn95hnhbth">
            <p className="text-sm font-semibold uppercase tracking-wide text-ink/60" data-id="element-184" data-mp="1zaw9bs3223vv">
              Total value: <span className="line-through" data-id="element-185" data-mp="1ui36j9r5d5mf">$294</span>
            </p>
            <p className="mt-2 text-[15px] text-ink/75" data-id="element-186" data-mp="1plcnqenyjvxb">But today, the complete Liposuction Case Lab™ is yours for</p>
            <p className="mt-1 font-display text-7xl font-black leading-none text-navy sm:text-8xl" data-id="element-187" data-mp="2n0qls8jgpqfl">$27</p>
            <p className="mt-2 text-sm font-extrabold uppercase tracking-wider text-cta" data-id="element-188" data-mp="2i7nrtzarweyv">One-time payment</p>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-left text-[13px] font-semibold text-navy" data-id="element-189" data-mp="31690hhmy5hku">
              {["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees"].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-190" data-mp="2wer0avsqzl0x">
                  <CheckCircle2Icon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-191" data-mp="2wcxufipyl4tz" />
                  {t}
                </li>)}
            </ul>
          </div>

          <p className="mt-4 flex items-start justify-center gap-2 text-center text-[13px] font-medium text-ink/70" data-id="element-192" data-mp="2nfngtqpo53lw">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-skydeep" aria-hidden="true" data-id="element-193" data-mp="29ge10s5dkbig" />
            Price in USD. Your local currency is converted automatically at checkout.
          </p>

          <div className="mt-5" data-id="element-194" data-mp="7npsq4dvixvt">
            <CTAButton label="Get Liposuction Case Lab™ for $27" data-id="element-195" data-mp="bojkx9ycmyui" />
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-ink/60" data-id="element-196" data-mp="bm73qz0f0sii">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-197" data-mp="1w4hnottqiml9" /> Secure checkout · Download immediately · 7-day guarantee
          </p>
        </div>

        <Countdown dark data-id="element-198" data-mp="25wnew1c5wzze" />
        <ScarcityBar data-id="element-199" data-mp="25xyd7lmu9fj4" />
      </div>
    </section>;
}